/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MailingAddress.scss';

import { func, string, array } from 'prop-types';

import React from 'react';

const SelectDropdown = ({ value, onBlur, onChange, options }) => {
  return (
    <select
      className="address-select"
      value={value}
      onBlur={onBlur}
      onChange={onChange}>
      <option value="">Select</option>
      {options.map((option, idx) => (
        <option key={idx} value={option.code}>
          {option.name}
        </option>
      ))}
    </select>
  );
};

SelectDropdown.propTypes = {
  onBlur: func.isRequired,
  onChange: func.isRequired,
  defaultValue: string,
  options: array.isRequired
};

export default SelectDropdown;
